export default class QuantityInput extends EventTarget {
  static Selector = '[data-type="quantity-input"]';

  static ChangeEventType = "change";

  #quantity = 0;

  #min = 0;

  #max = 0;

  #incrementButton: HTMLElement;

  #decrementButton: HTMLElement;

  #quantityInput: HTMLInputElement;

  constructor(element: HTMLElement) {
    super();
    const incrementButton = element.querySelector('[data-type="increment"]');
    const decrementButton = element.querySelector('[data-type="decrement"]');
    const quantityInput = element.querySelector('[data-type="quantity"]');

    if (
      incrementButton instanceof HTMLElement &&
      decrementButton instanceof HTMLElement &&
      quantityInput instanceof HTMLInputElement
    ) {
      this.#incrementButton = incrementButton;
      this.#decrementButton = decrementButton;
      this.#quantityInput = quantityInput;

      this.#quantity = Number(quantityInput.value) || 1;
      this.#min = Number(quantityInput.min) || Number.NEGATIVE_INFINITY;
      this.#max = Number(quantityInput.max) || Number.POSITIVE_INFINITY;

      this.#incrementButton.addEventListener("click", this.#onIncrementClick);
      this.#decrementButton.addEventListener("click", this.#onDecrementClick);
      this.#quantityInput.addEventListener(
        "change",
        this.#onQuantityInputChange,
      );
      this.#quantityInput.addEventListener("blur", this.#onQuantityInputBlur);
    }
  }

  get value() {
    return this.#quantity;
  }

  #onIncrementClick = (e: MouseEvent) => {
    e.stopPropagation();

    const value = Math.min(this.#quantity + 1, this.#max);

    this.#quantity = value;
    this.#quantityInput.value = value.toString();

    this.dispatchEvent(new Event(QuantityInput.ChangeEventType));
  };

  #onDecrementClick = (e: MouseEvent) => {
    e.stopPropagation();

    const value = Math.max(this.#quantity - 1, this.#min);

    this.#quantity = value;
    this.#quantityInput.value = value.toString();

    this.dispatchEvent(new Event(QuantityInput.ChangeEventType));
  };

  #onQuantityInputChange = (e: Event) => {
    e.stopPropagation();
  };

  #onQuantityInputBlur = () => {
    let value = Number(this.#quantityInput.value) || 1;

    value = Math.max(Math.min(value, this.#max), this.#min);

    this.#quantity = value;
    this.#quantityInput.value = value.toString();

    this.dispatchEvent(new Event(QuantityInput.ChangeEventType));
  };
}
